import {AxiosResponse} from 'axios';
import {useQuery} from '@tanstack/react-query';
import {IApiDataResponse} from '../../dto/API.dto';
import {apiGet} from '../../axiosConfig';
import {IUser} from '../../dto/User.dto';

export const getPRApiPath = () => `/v1/user/product-representative`;

const getProdRepresentativeList = () => {
  return apiGet(getPRApiPath()).then(
    (response: AxiosResponse<IApiDataResponse<IUser[]>>) => {
      return response.data.data;
    },
  );
};

export const useRqListProdRepresentative = () => {
  return useQuery({
    queryKey: [getPRApiPath()],
    queryFn: () => getProdRepresentativeList(),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: true,
  });
};

export interface IState {
  id: number;
  name: string;
}

const getStates = () => {
  return apiGet(`/v1/state`).then(
    (response: AxiosResponse<IApiDataResponse<IState[]>>) => response.data.data,
  );
};

export const useRqListStates = () => {
  return useQuery({
    queryKey: [`/v1/state`],
    queryFn: () => getStates(),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: true,
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
